import React from "react";
import { useUserContext } from "context/UserContext";
import VenuesBK from "layouts/BK/venues";
import { normalizeRoleLevel } from "utils/roleUtils";

function Venues() {
  const { roleLevel } = useUserContext() || {};
  if (normalizeRoleLevel(roleLevel)) {
    return <VenuesBK />;
  }
  return null;
}

export default Venues;
